import { Text } from '@tonic-one/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDashboardServicesStore } from 'src/models/useDashboardServicesModel';
import { formatTableServices, sortTableDataByService } from 'src/utils/table';

import Percent from '../../Charts/Percent';
import TableTemplate from '../../Charts/TableTemplate';
import DashboardCard from '../../Layout/DashboardCard';
import RedirectLink from '@Components/RedirectLink';
import { generateRedirectUrlToLog } from '@Log/shared';
import { getServiceNameByValue } from '@Utils/service';
import { LogTypeEnum } from '@Types/log';

const QuishingDetections = (props: { data: any; day: string }) => {
  const { t } = useTranslation();
  const servicesModel = useDashboardServicesStore();

  const config = [
    { width: '20%', grow: 2, align: 'left', tooltip: true },
    { width: '12%', grow: 1, align: 'right' },
    { width: '12%', grow: 1, align: 'right' },
    { width: '10%', grow: 1, align: 'right' },
  ];
  const header = [
    t('dashboard.chart.column.service'),
    t(`dashboard.chart.column.last${props.day}`),
    t(`dashboard.chart.column.prev${props.day}`),
    t('dashboard.chart.column.change'),
  ];

  const rawData = formatTableServices(
    props.data?.summaryQuishing?.[props.day],
    props.data?.summaryQuishingPrevious?.[props.day],
    servicesModel.services
  );
  const data = sortTableDataByService(rawData).map((row) => [
    t(`common.service.${row[0]}`),
    row[1] === 0 ? (
      0
    ) : (
      <RedirectLink
        href={`logs?${generateRedirectUrlToLog(
          [
            {
              field: 'mergedSecurityRiskName',
              values: ['VAN_QUISHING.UMXX', 'QUISHING'],
              type: 'match',
            },
            {
              field: 'scanSource',
              values: [getServiceNameByValue(row[0])],
              type: 'terms',
            },
          ],
          props.day,
          LogTypeEnum.DETECTION
        )}`}
      >
        <Text>{row[1]}</Text>
      </RedirectLink>
    ),
    row[2],
    <Percent n={row[row.length - 1]} />,
  ]);

  return (
    <DashboardCard
      title={t('dashboard.chart.title.quishingDetections.content')}
      iconContent={t('dashboard.chart.title.quishingDetections.tooltip')}
    >
      <TableTemplate config={config} header={header} data={data} />
    </DashboardCard>
  );
};

export default React.memo(QuishingDetections);
